import { useEffect, useState, useRef, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import axios from 'axios';
import PointsTable from '../components/PointsTable.jsx';
import {
  Loading,
  TablePagination,
  Caret
} from '../components/utility/Utility';
import '../assets/css/components/program.css';
import { useSearchParams } from 'react-router-dom';
import { ActionDescription, InitiateTutorial } from '../components/Onboarding.jsx';

export default function Customers() {
  const {logout, getJwtToken} = useContext(AuthContext);
  const [customers, setCustomers] = useState(false);
  const [query, setQuery] = useState('');
  const [sort, setSort] = useState({points: -1});
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(false);
  const lastQuery = useRef('');
  const [searchParams, setSearchParams] = useSearchParams();
  const [tutorial, setTutorial] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const tutorial = searchParams.get('tutorial');
    if (tutorial === 'true') setTutorial(1);
  }, [])

  useEffect(() => {
    if (tutorial === 2) paginate();
    if (tutorial === 3) setSearchTerm("johnsmith@gmail.com");
  }, [tutorial])

  const paginate = async () => {
    setCustomers(false);
    try {
      const token = await getJwtToken();
      const res = await axios.get('https://api.amplifyloyalty.com/app/customers',
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            page,
            sort: JSON.stringify(sort),
            query,
            tutorial: tutorial > 1 ? true : false
          }
        }
      );
      
      let info = {...res.data}
      delete info.docs;
      setPagination(info)
      setCustomers(res.data.docs);

    } catch (err) {
      console.log(err);
      // It's possible a 401/403 error could be caught here, which would indicate an expired token.
      // You might want to handle that by calling logout().
    }
  }

  const search = (value) => {
    if (!tutorial) {
      setTimeout(() => {
          let currentValue = document.querySelector('.customers-table__search').value;
          if (currentValue === value && value !== lastQuery.current) {
            setCustomers(false);
            lastQuery.current = value;
            setQuery(value);
          }
      }, 1500)
    } else {
      setCustomers(false);
      setQuery(value);
    }
  }

  useEffect(() => {
    search(searchTerm);
  }, [searchTerm])

  useEffect(() => {
    paginate();
  }, [query, sort, page])

  return (
    <div className="customers">
      {tutorial === 1 && 
        <InitiateTutorial 
          text="In this guide, you will learn how search for customers, view their activity, and make updates to their points. Fake customers will be used during this tutorial and any changes you make will not be saved."
          header="Customers" 
          setTutorial={setTutorial}
        />
      }
      <section className="customers-table__container" style={{position: "relative"}}>
        <div className="customers-table" style={{position: "relative"}}>
          <div className="customers-table__input-container" style={{position: "relative"}}>
            <input 
              type="text" 
              className="customers-table__search" 
              placeholder="Search customers" 
              onChange={(e) => setSearchTerm(e.target.value)}
              style={tutorial === 2 ? {
                position: "relative", 
                zIndex: "55", 
                backgroundColor: "#fff",
                boxShadow: "0 0 10px #fff",
              }: {}}
              disabled={tutorial === 2 || false}
              value={searchTerm}
            />
            {tutorial === 2 && 
              <ActionDescription 
                text={`Use the search bar to search for customers by their email address.`}
                style={{width: "220px", left: "215px", top:"-37px"}}
                triangle={{left: "-18px", top: "calc(50% - 9px)", transform: "rotate(-90deg)"}}
                tutorial={tutorial}
                setTutorial={setTutorial}
                next="Next"
              />
            }
          </div>
          <div className="customers-table__table-container">
            <div className="customers-table__header">
              <div className="customers-table__heading customers-table__sort-heading" onClick={() => setSort({email: sort.email ? sort.email * -1 : -1})}>
                <div className="customers-table__heading-text">Customer</div>
                {sort.email && 
                  <Caret className="customers-table__heading-caret" direction={sort.email*-1}/>
                }
              </div>
              <div className="customers-table__metrics">
                <div className="customers-table__heading">
                  <div className="customers-table__sort-container" onClick={() => setSort({points: sort.points * -1})}>
                    <div className="customers-table__heading-text">Points</div>
                    {sort.points && 
                      <Caret className="customers-table__heading-caret" direction={sort.points}/>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="customers-table__body">
              {!customers && <Loading className="customers-table__loading" />}
              {customers.length === 0 && 
                <div className="customers-table__empty-warning">No Customers found.</div>
              }
              {customers.length > 0 && 
                customers.map((customer, i) => {
                  return (
                    <div key={customer.email} className="customers-table__row" style={{position: "relative"}}>
                      <a 
                        href={`/app/customers/${customer._id}${tutorial > 0 ? "?tutorial=true" : ""}`} 
                        className="customers-table__cell customers-table__cell--link"
                        style={tutorial === 3 && i === 0 ? {
                          position: "relative", 
                          zIndex: "55", 
                          backgroundColor: "#fff",
                          boxShadow: "0 0 10px #fff",
                          padding: "5px",
                          borderRadius: "var(--small-border-radius)"
                        } : {}}
                      >{customer.email}</a>
                      <div className="customers-table__metrics">
                        <div className="customers-table__cell">{Intl.NumberFormat('en-us').format(Math.floor(customer.points))}</div>
                      </div>
                      {tutorial === 3 && i === 0 && 
                        <ActionDescription 
                          text={`Click on the customer's email to view their profile.`}
                          style={{width: "220px", left: "195px", top:"-9px"}}
                          triangle={{left: "-18px", top: "calc(50% - 9px)", transform: "rotate(-90deg)"}}
                          tutorial={tutorial}
                          setTutorial={setTutorial}
                        />
                      }
                    </div>
                  )
                })
              }
            </div>
            {pagination && 
              <TablePagination 
                options={pagination} 
                docType="customers" 
                previous={() => setPage(pagination.prevPage)} 
                next={() => setPage(pagination.nextPage)}
              />
            }
          </div>
        </div>
      </section>
    </div>
  )
}